import { modifier } from 'ember-modifier';
import type { Filter } from '../utils/filters';
/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: BUSL-1.1
 */

/**
 * Applies and updates a custom CSS property based on updates to a tracked/computed ember value.
 */
export default modifier(function updateData(
  _element: HTMLElement,
  [callback, filters]: [(filters: Filter[]) => void, Filter[]],
) {
  callback(filters);
});
